// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek <roman.morawek@embyt.com>

import { IEnergyMeter } from "shared/types/parameter";
import { isSet, round } from "shared/utils/utils";

class EnergyMeter {
  readonly parameter: IEnergyMeter;
  readonly value: number | undefined;
  // the counter value is kept while offline, thus only the module status is relevant
  readonly isOffline: boolean;

  constructor(
    parameter: IEnergyMeter,
    data: number | undefined,
    moduleStatus: boolean | undefined,
  ) {
    this.parameter = parameter;
    this.value = data;
    this.isOffline = moduleStatus === false;
  }

  public getText(): string {
    if (!isSet(this.value) || isNaN(this.value)) {
      return "-";
    }
    const valueString = round(this.value, 1).toLocaleString();
    return valueString + " " + this.parameter.unit;
  }

  public getValueText(): string {
    if (!isSet(this.value)) {
      return "-";
    }
    const valueString = round(this.value, 1).toLocaleString();
    return valueString;
  }

  public getUnitText(): string {
    return this.parameter.unit;
  }
}

export default EnergyMeter;
